module.exports = __webpack_public_path__ + "static/media/ringcentral-logo.b42d4c73.svg";